var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvrPreference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97607 16.7738V3.67857V3.08333L4.27369 2.4881L4.86893 1.89286L5.16655 1.59524L5.76179 1.29762L6.35703 1H6.95226H9.33322L9.92846 1.29762L10.5237 1.89286L11.1189 2.4881L11.4166 3.08333L11.7142 3.67857V16.1786L11.4166 16.7738L11.1189 17.369L10.5237 17.9643L9.92846 18.5595L9.63084 18.8571L9.0356 19.1548H6.35703L5.76179 18.8571L5.16655 18.2619L4.86893 17.9643L4.27369 17.369L3.97607 16.7738Z",
    fill: "#CCCCCC",
    stroke: "#004357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27393 5.76172H6.05964",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6072 4.86928L12.3096 5.46452L11.7144 6.35738V7.54785V8.73833L12.012 9.33357L12.3096 9.9288L12.9048 10.3946L13.2025 10.524L13.7977 10.8217L14.0953 11.4169L13.7977 12.0121L13.5001 12.6074L13.2025 13.2026L12.6072 13.5002H12.9048H13.7977H14.6905L15.2858 13.2026L15.5834 12.3098L16.1786 12.6074L16.7739 12.905L17.9644 13.2026H20.6429H21.5358L22.131 12.905L22.7263 12.6074L23.3215 12.0121L23.9167 11.7145L24.512 11.1193L25.1072 10.524L25.4048 9.9288L25.7025 9.33357L26.0001 8.44071V5.95467V5.1669L25.7025 4.57166L25.1072 3.97642L24.512 3.38118L24.2144 3.08357L23.6191 2.48833L23.0239 2.19071L22.4286 1.89309L21.8334 1.59547L21.2382 1.29785H20.9405H17.0715H16.4763L15.881 1.59547L15.2858 1.89309L14.6905 2.48833L14.0953 3.08357L13.5001 3.6788L12.9048 4.27404L12.6072 4.86928Z",
    fill: "#004357",
    stroke: "#004357",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.6907V15.8812V16.774L1.29762 17.3693L1.59524 17.9645L2.19048 18.8574L2.78571 19.4526L3.38095 20.0478L4.27381 20.6431L5.16667 21.2383L5.7619 21.5359H6.65476H7.54762H8.44048H9.63095H10.2262L10.8214 21.2383L11.4167 20.9407L12.0119 20.3454L12.6071 19.7502L13.2024 18.8574L13.7976 17.9645L14.3929 17.0716L14.6905 16.4764V15.5835V14.9883V14.3931",
    stroke: "#004357",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84519 21.5356V26.2975H2.19043H13.5",
    stroke: "#004357",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27393 9.3335H6.05964",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27393 12.9048H6.05964",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 12.9048H11.4166",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 9.3335H11.4166",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 5.76172H11.4166",
    stroke: "#004357",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4524,
    cy: 7.24981,
    r: 1.4881,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8812,
    cy: 7.24981,
    r: 1.4881,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0237,
    cy: 7.24981,
    r: 1.4881,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvrPreference);
export default __webpack_public_path__ + "static/media/ivr_preference.ee423d64de55e2a0bc1404c197f04e69.svg";
export { ForwardRef as ReactComponent };